import React, { useState } from "react"
// import { BtnMenu, BtnMenuProfile, Logo } from "../components/layout/menu_header"
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import DressingRoom from "../components/layout/dressing_room"
import Questions from "../components/layout/questions"
import { defPath, fetchPath } from "../config/defPath"
import Popups from "../components/layout/popup"
import { useSession } from "../hooks/useState"
import CustomizePlayer from "../components/layout/CustomizePlayer"
import gsap from "gsap";

import { sendQuestion, saveCollectable } from "../classes/popsController"
import { triggerCustomEvent, listenerCustomEvent } from '../classes/eventController';

declare global {
  interface Window {
    drupalSettings: any
  }
}

export default function Camerino() {
  const [selectedPant, setSelectedPant] = useState(false);
  const [customizePlayerState, setCustomizePlayerState] = useState(false)
  const { user, updateRedeemables } = useSession(state => state)
  const [avatar, updateAvatar] = useState({})
  const [animateToggle, setAnimateToggle] = useState(true)

  const validateRegister = async () => {

    const questionBody = sessionStorage.getItem('daniela')
    const collectableBody = sessionStorage.getItem('paola')
    if (questionBody) {
      const statusQuestion = await sendQuestion(JSON.parse(questionBody))
      sessionStorage.removeItem('daniela')
    }

    if (collectableBody) {
      const statusRegister = await saveCollectable(collectableBody)
      sessionStorage.removeItem('paola')
    }

  }

  React.useEffect(() => {
    updateAvatar(user.json_avatar)
    validateRegister()
  }, [user])

  React.useEffect(() => {
    handleCurtomizerPlayer()
    if (location.port) { // local Mateo localhost:3030
      return
    }
    if (window.drupalSettings.user.uid === 0) location.href = '/estadio-aguila/iniciar-sesion'

    listenerCustomEvent("saveAvatar", (event: CustomEvent) => {
      sendAvatar()
      const newArticle = event.detail.item.replace('.png', '')
      if (user.list_articles?.includes(newArticle)) return

      newArticle && updateRedeemables(newArticle)
    })
  }, [])

  async function sendAvatar() {
    let url = `${fetchPath}/aguila/loyalty/save/avatar`

    try {
      let info = { json: window.avatar.jsonTemp }

      let res: any = await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(info)
      })

      let data = await res.json()

      if (res.ok) {
        window.avatar.purchasedItem()

        setAnimateToggle(false)
        setTimeout(() => {
          handleCurtomizerPlayer()
        }, 350)
        triggerCustomEvent('renderAlert', {
          title: '¡Que estilo!',
          desc: `${data.message}`,
          type: 'great',
          time: 3000
        })
      }
    }

    catch (error) {
      console.warn("error", error)
    }
  }

  const handleCurtomizerPlayer = () => {
    if (customizePlayerState) {
      document.querySelector('.customizePlayer')?.classList.remove('active')
      customizePlayerAnimation(true)
      setAnimateToggle(true)
      window.cameraController.panning('CamStep2', 3)
      setTimeout(() => {
        setCustomizePlayerState(false)
      }, 1000);
    } else {
      setCustomizePlayerState(true)
      window.cameraController.panning('CamStep1', 1)
      setTimeout(() => {
        customizePlayerAnimation(false)
        document.querySelector('.customizePlayer')?.classList.add('active')
      }, 100);
    }
  }

  const openHelp = (e: any) => {
    e.preventDefault()

    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Help',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_HelpIcon',
      'element_text': 'Ayuda',
    });

    if (e.currentTarget.href) window.location.href = e.currentTarget.href
  }

  const handdleSoundClick = (event: any) => {
    if (event.target.classList.contains('muted')) {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Sound Off',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_SoundIcon',
        'element_text': 'Sonido',
      });
    }

    else {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Card',
        'event_label': 'Sound On',
        'interaction': 'true',
        'component_name': 'Modo_Carrera_SoundIcon',
        'element_text': 'Sonido',
      });
    }
  }

  return (
    <>
      {/* Page HTML */}
      <section id='king-camerino'>
        {/* <Controls isStadium= {false} /> */}

        <div id="deviceRotated">
          <span>
            <img src={`${defPath}/assets/images/deviceRotated.svg`} />
            Rota tu dispositivo.
          </span>
        </div>

        {/* {
          isAcceptAge && (
            <div className={`${isAcceptAge ? 'loader' : ''}`}>
              <div className='loader-ball'>&nbsp;</div>
              <span className='loader-value'>0%</span>
            </div>
          )
        } */}
        <div className='loader'>
          <div className='loader-ball'>&nbsp;</div>
          <span className='loader-value'>0%</span>
        </div>

        {/* <Logo />
                <BtnMenu />
                <BtnMenuProfile /> */}
        {/* <div style={{ opacity: waitLoader ? '0' : '1' }}> */}
          <NewHeader />
          <Questions />
          <Modal />
          <section className="layout-controls">
            <a href="/estadio-aguila/guia" className="ar__btn hidden" onClick={openHelp}>
              <img className="layout-controls-img" src={`${defPath}/assets/images/icons/icon_help.svg`} alt="icono ayuda" />
            </a>
            <button className="ar__btn UI-sound" onClick={handdleSoundClick}>
            </button>
          </section>
          <Popups />
          {/* <input onClick={handleCurtomizerPlayer} type="button"  className="btnPrueba" value="popup" /> */}


          {customizePlayerState && <CustomizePlayer closeMenu={handleCurtomizerPlayer} />}

          {!customizePlayerState && avatar && <DressingRoom closeMenu={handleCurtomizerPlayer} updatePant={setSelectedPant} animateToggle={animateToggle} setAnimateToggle={setAnimateToggle} />}

          <canvas id='canvas-camerino'></canvas>

          <picture className='king-camerino-bg'>
            <source srcSet={`${defPath}/assets/images/camerino/bg_camerino-op.jpg`} media="(min-width: 600px)" />
            <img src={`${defPath}/assets/images/camerino/bg_camerino_small-op.jpg`} alt="Fondo si somos Aguila" />
          </picture>

          <div className='test_ui'>
            {/* <div className="btn_ btn_step2">Step 2</div>
                    <div className="btn_ btn_step1">Step 1</div> */}

            <div className='cont'>
              <span className='type1'>
                <h3>Genero</h3>
                <div className="btn_" data-t='gender' data-v='Hombre'>Hombre</div>
                <div className="btn_" data-t='gender' data-v='Mujer'>Mujer</div>
              </span>

              <span className='type2'>
                <h3>Piel</h3>
                <div className="btn_" data-t='skin' data-v='A'>A</div>
                <div className="btn_" data-t='skin' data-v='D'>D</div>
                <div className="btn_" data-t='skin' data-v='I'>I</div>
              </span>

              <hr></hr>

              <span className='type3'>
                <h3>Cabello</h3>
                <div className="btn_" data-t='hair' data-v='00'>00</div>
                <div className="btn_" data-t='hair' data-v='01'>01</div>
                <div className="btn_" data-t='hair' data-v='02'>02</div>
                <div className="btn_" data-t='hair' data-v='03'>03</div>
              </span>
              <span className='type9'>
                <div className="btn_" data-t='color' data-v='cabello_ffff00' style={{ backgroundColor: '#ffff00' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='cabello_00ff00' style={{ backgroundColor: '#00ff00' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='cabello_00ffff' style={{ backgroundColor: '#00ffff' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='cabello_ff00ff' style={{ backgroundColor: '#ff00ff' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='cabello_002D6E' style={{ backgroundColor: '#002D6E' }}>&nbsp;</div>
              </span>

              <hr></hr>

              <span className='type8'>
                <h3>Barba</h3>
                <div className="btn_" data-t='beard' data-v='00'>00</div>
                <div className="btn_" data-t='beard' data-v='01'>01</div>
                <div className="btn_" data-t='beard' data-v='02'>02</div>
                <div className="btn_" data-t='beard' data-v='03'>03</div>
              </span>
              <span className='type9'>
                <div className="btn_" data-t='color' data-v='barba_ffff00' style={{ backgroundColor: '#ffff00' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='barba_00ff00' style={{ backgroundColor: '#00ff00' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='barba_00ffff' style={{ backgroundColor: '#00ffff' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='barba_ff00ff' style={{ backgroundColor: '#ff00ff' }}>&nbsp;</div>
                <div className="btn_" data-t='color' data-v='barba_002D6E' style={{ backgroundColor: '#002D6E' }}>&nbsp;</div>
              </span>

              <hr></hr>

              <span className='sup type4'> {/* General objects */}
                <h3>Camisa</h3>
                <div className="btn_" data-t='item' data-v='Sup_camiseta_01'>01</div>
                <div className="btn_" data-t='item' data-v='Sup_camiseta_02'>02</div>
                <div className="btn_" data-t='item' data-v='Sup_camiseta_03'>03</div>
              </span>
              <span className='sup type4'>
                <h3>Hoodie</h3>
                <div className="btn_" data-t='item' data-v='Sup_hoodie_01'>01</div>
                <div className="btn_" data-t='item' data-v='Sup_hoodie_02'>02</div>
                <div className="btn_" data-t='item' data-v='Sup_hoodie_03'>03</div>
              </span>
              <span className='sup type4'>
                <h3>Chaqueta</h3>
                <div className="btn_" data-t='item' data-v='Sup_chaqueta_01'>01</div>
                <div className="btn_" data-t='item' data-v='Sup_chaqueta_02'>02</div>
                <div className="btn_" data-t='item' data-v='Sup_chaqueta_03'>03</div>
              </span>

              <hr></hr>

              <span className='sup type4'>
                <h3>pantalonetas</h3>
                <div className="btn_" data-t='item' data-v='Inf_pant-corta_01'>01c</div>
                <div className="btn_" data-t='item' data-v='Inf_pant-corta_02'>02c</div>
                <div className="btn_" data-t='item' data-v='Inf_pant-larga_01'>01l</div>
                <div className="btn_" data-t='item' data-v='Inf_pant-larga_02'>02l</div>
              </span>
              <span className='sup type4'>
                <h3>jean</h3>
                <div className="btn_" data-t='item' data-v='Inf_jean_01'>01</div>
                <div className="btn_" data-t='item' data-v='Inf_jean_02'>02</div>
                <div className="btn_" data-t='item' data-v='Inf_jean_03'>03</div>
              </span>
              <span className='sup type4'>
                <h3>pesquero</h3>
                <div className="btn_" data-t='item' data-v='Inf_pesquero_01'>01</div>
                <div className="btn_" data-t='item' data-v='Inf_pesquero_02'>02</div>
                <div className="btn_" data-t='item' data-v='Inf_pesquero_03'>03</div>
              </span>
              <span className='sup type4'>
                <h3>hopper</h3>
                <div className="btn_" data-t='item' data-v='Inf_hopper_01'>01</div>
                <div className="btn_" data-t='item' data-v='Inf_hopper_02'>02</div>
                <div className="btn_" data-t='item' data-v='Inf_hopper_03'>03</div>
              </span>

              <hr></hr>

              <span className='sup type4'>
                <h3>guayos</h3>
                <div className="btn_" data-t='item' data-v='Cal_guayos_01'>01</div>
                <div className="btn_" data-t='item' data-v='Cal_guayos_02'>02</div>
                <div className="btn_" data-t='item' data-v='Cal_guayos_03'>03</div>
              </span>
              <span className='sup type4'>
                <h3>tenis</h3>
                <div className="btn_" data-t='item' data-v='Cal_tenis_01'>01</div>
                <div className="btn_" data-t='item' data-v='Cal_tenis_02'>02</div>
                <div className="btn_" data-t='item' data-v='Cal_tenis_03'>03</div>
              </span>
              <span className='sup type4'>
                <h3>botines</h3>
                <div className="btn_" data-t='item' data-v='Cal_botines_01'>01</div>
                <div className="btn_" data-t='item' data-v='Cal_botines_02'>02</div>
                <div className="btn_" data-t='item' data-v='Cal_botines_03'>03</div>
              </span>
              <span className='sup type5'>
                <h3>medias</h3>
                <div className="btn_" data-t='socks' data-v='Cal_medias_00'>00</div>
                <div className="btn_" data-t='socks' data-v='Cal_medias_01'>01</div>
                <div className="btn_" data-t='socks' data-v='Cal_medias_02'>02</div>
                <div className="btn_" data-t='socks' data-v='Cal_medias_03'>03</div>
              </span>


              <hr></hr>

              <span className='sup type6'>
                <h3>sombreros</h3>
                <div className="btn_" data-t='acc' data-v='Acc_sombrero_00'>00</div>
                <div className="btn_" data-t='acc' data-v='Acc_sombrero-01_01'>01</div>
                <div className="btn_" data-t='acc' data-v='Acc_sombrero-01_02'>02</div>
                <div className="btn_" data-t='acc' data-v='Acc_sombrero-01_03'>03</div>
              </span>
              <span className='sup type6'>
                <h3>gafas</h3>
                <div className="btn_" data-t='acc' data-v='Acc_gafas_00'>00</div>
                <div className="btn_" data-t='acc' data-v='Acc_gafas-01'>01</div>
                <div className="btn_" data-t='acc' data-v='Acc_gafas-02'>02</div>
                <div className="btn_" data-t='acc' data-v='Acc_gafas-03'>03</div>
              </span>
              <span className='sup type6'>
                <h3>guantes</h3>
                <div className="btn_" data-t='acc' data-v='Acc_guantes_00'>00</div>
                <div className="btn_" data-t='acc' data-v='Acc_guantes_01'>01</div>
                <div className="btn_" data-t='acc' data-v='Acc_guantes_02'>02</div>
                <div className="btn_" data-t='acc' data-v='Acc_guantes_03'>03</div>
              </span>

              <hr></hr>

              <span className='sup'>
                <h3>canjeables</h3>
                {/* <div className="btn_" data-t='item' data-v='Cal_guayosOro_001'>01</div>
                            <div className="btn_" data-t='item' data-v='Sup_camiseta_001'>02</div>
                            <div className="btn_" data-t='item' data-v='Inf_jeanOro_001'>03</div> */}

                <div className="btn_" data-t='acc' data-v='Acc_mascara-leon'>Leon</div>
                <div className="btn_" data-t='item' data-v='Sup_camiseta_002'>roja</div>
                <div className="btn_" data-t='acc' data-v='Acc_mascara-tigre'>tigre</div>
              </span>

              <hr /><hr />

              <span className='save saveJson'>
                <h3>Guardar Json</h3>
                <div className="btn_" data-t='saveJson'>Guardar</div>
              </span>

            </div>
          </div>
        {/* </div> */}
      </section>

    </>
  )
}

const customizePlayerAnimation = (condicionaal: boolean) => {
  const widthSize = window.innerWidth;
  const timeline = gsap.timeline({
    defaults: {
      stagger: 0,
    }
  })
  if (widthSize <= 1119) {
    if (!condicionaal) {
      timeline.to('.customizePlayer__body', { opacity: 1, right: 0, duration: .3 }, 0)
      timeline.to(".customizePlayer__right .navCustomizer__container", { opacity: 1, right: -2, duration: .7 }, 0)
      timeline.to(".customizePlayer__left .navCustomizer__container", { opacity: 1, left: 2, duration: .7 }, 0)
      timeline.to(".ar__btn--volver", { opacity: 1, bottom: '5%', duration: 2 }, .8)
    } else {
      timeline.to(".ar__btn--volver", { opacity: 0, bottom: '-100%', duration: 2 }, 0)
      timeline.to(".customizePlayer__right .navCustomizer__container", { opacity: 0, right: -100, duration: .7 }, 0)
      timeline.to(".customizePlayer__left .navCustomizer__container", { opacity: 0, left: 100, duration: .7 }, 0)
      timeline.to('.customizePlayer__body', { opacity: 0, right: '-100%', duration: .3 }, .3)
    }
  } else {
    if (!condicionaal) {
      timeline.to(".ar__btn--volver", { opacity: 1, bottom: '5%', duration: .3 }, 0)
      timeline.to('.customizePlayer__left', { opacity: 1, left: 0, duration: .3 }, 0)
      timeline.to('.customizePlayer__right', { opacity: 1, right: 0, duration: .3 }, 0)
      timeline.to(".customizePlayer__right .navCustomizer__container", { opacity: 1, right: -2, duration: .7, }, 0)
      timeline.to(".customizePlayer__left .navCustomizer__container", { opacity: 1, left: 2, duration: .7, }, 0)
    } else {
      timeline.to('.customizePlayer__left .navCustomizer__container', { opacity: 0, left: 100, duration: .7, }, 0)
      timeline.to('.customizePlayer__right .navCustomizer__container', { opacity: 0, right: -100, duration: .7 }, 0)
      timeline.to('.customizePlayer__right', { right: -100, opacity: 0, duration: .3 }, .5)
      timeline.to('.customizePlayer__left', { left: -100, opacity: 0, duration: .3 }, .5)
      timeline.to('.customizePlayer__body', { opacity: 0, right: 0, duration: 0 }, .8)
      timeline.to(".ar__btn--volver", { opacity: 0, bottom: '-100%', duration: .3 }, 0)
    }
  }
}
